import React, { useEffect, useState } from 'react';

const PetChoiceQuestion = ({
  title,
  subtitle = '',
  options = [],
  onSelect,
  onBack,
  initialValue = '',
}) => {
  const [selectedValue, setSelectedValue] = useState(String(initialValue || ''));

  useEffect(() => {
    setSelectedValue(String(initialValue || ''));
  }, [initialValue]);

  const handleSelect = (value) => {
    if (selectedValue === value) {
      onSelect(value);
      return;
    }

    setSelectedValue(value);
    window.setTimeout(() => {
      onSelect(value);
    }, 180);
  };

  return (
    <div className="max-w-3xl mx-auto overflow-x-hidden">
      <div className="text-center mb-8 lg:mb-10">
        <h2 className="text-3xl sm:text-4xl font-bold text-purple-700 mb-3">{title}</h2>
        {subtitle ? (
          <p className="text-lg lg:text-xl text-gray-600">{subtitle}</p>
        ) : null}
      </div>

      <div className="bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5">
          {options.map((option) => {
            const isSelected = selectedValue === option.value;

            return (
              <button
                key={option.value}
                type="button"
                onClick={() => handleSelect(option.value)}
                className={`group relative overflow-hidden rounded-2xl border px-6 py-7 lg:px-7 lg:py-9 text-left shadow-sm transition-all duration-300 ${
                  isSelected
                    ? 'border-transparent bg-gradient-to-r from-pink-50 to-purple-50 ring-2 ring-pink-200 shadow-md'
                    : 'border-purple-100 bg-gradient-to-br from-white to-purple-50/60 hover:-translate-y-0.5 hover:border-pink-200 hover:shadow-md'
                }`}
              >
                <div
                  className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-pink-500 to-purple-500 transition-opacity duration-300 ${
                    isSelected ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'
                  }`}
                />
                <div className="relative flex items-center justify-between gap-4">
                  <span className="block text-xl lg:text-2xl font-semibold text-slate-800">{option.label}</span>
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-full border text-sm font-semibold transition-colors ${
                      isSelected
                        ? 'border-pink-300 bg-white text-pink-600'
                        : 'border-purple-100 bg-white text-purple-300'
                    }`}
                  >
                    {isSelected ? '✓' : ''}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {typeof onBack === 'function' ? (
        <button
          type="button"
          onClick={onBack}
          className="mt-4 w-full rounded-full border border-purple-200 px-6 py-3 text-base font-semibold text-purple-600 transition-all duration-300 hover:bg-purple-50 lg:text-lg"
        >
          Back
        </button>
      ) : null}
    </div>
  );
};

export default PetChoiceQuestion;
